import { useEffect } from 'react';

/**
 * Hook to preload critical resources for better performance
 */
export const useResourcePreloader = () => {
    useEffect(() => {
        // Preload critical images
        const criticalImages = [
            '/logo.png',
            '/baker.png',
            '/bg.png'
        ];

        const preloadPromises = criticalImages.map(src => {
            return new Promise((resolve) => {
                const img = new Image();
                img.onload = () => resolve(src);
                img.onerror = () => {
                    console.warn(`Failed to preload image: ${src}`);
                    resolve(src); // Resolve anyway to not block
                };
                img.src = src;
            });
        });

        Promise.all(preloadPromises).then(() => {
            console.log('✅ Critical images preloaded');
        });

        // Preload and cache font
        if ('fonts' in document) {
            document.fonts.ready.then(() => {
                console.log('✅ Fonts loaded');
            });
        }
    }, []);
};

export default useResourcePreloader;
